import React, { useEffect, useState } from 'react'
import ArrowDown from '../icons/ArrowDown'

const Accordion = ({ children }) => {
  const [openPanels, setOpenPanels] = useState([])

  useEffect(() => {
    const allPanels = React.Children.map(children, (_, index) => index)
    setOpenPanels(allPanels)
  }, [children])

  const togglePanel = (index) => {
    if (openPanels.includes(index)) {
      setOpenPanels(openPanels.filter((panelIndex) => panelIndex !== index))
    } else {
      setOpenPanels([...openPanels, index])
    }
  }

  return (
    <div className="accordion space-y-4">
      {React.Children.map(children, (child, index) =>
        React.cloneElement(child, {
          isOpen: openPanels.includes(index),
          onClick: () => togglePanel(index),
        })
      )}
    </div>
  )
}

const AccordionPanel = ({ isOpen, onClick, title, children }) => (
  <div className="accordion-panel">
    <div
      className="accordion-title cursor-pointer p-4 hover:bg-gray-200 transition flex justify-between items-center"
      onClick={onClick}
    >
      <h2 className="text-xl font-semibold text-black">{title}</h2>
      <div
        className={`transform transition-transform duration-300 ${
          isOpen ? 'rotate-180' : ''
        }`}
      >
        <ArrowDown color="black" />
      </div>
    </div>
    <div
      className={`accordion-content overflow-hidden transition-all duration-300 ${
        isOpen ? 'max-h-fit' : 'max-h-0'
      }`}
    >
      <div className="p-4">{children}</div>
    </div>
  </div>
)

export { Accordion, AccordionPanel }
